import { Checkbox, Input, Typography } from '@weareopenr/component-library';
import classnames from 'classnames/bind';
import { UseFormReturn, useWatch } from 'react-hook-form';
import styles from './OptionGroupPricing.module.scss';
import { IOptionGroupValues } from '../CreateOptionGroupModal/types';
import { Fragment } from 'react';
import { usePriceScheme } from 'src/hooks/usePriceScheme';
import { useSelectedPriceScheme } from '../../hooks/useSelectedPriceScheme/useSelectedPriceScheme';

const cx = classnames.bind(styles);

interface IOptionGroupPricingProps {
  formReturn: UseFormReturn<IOptionGroupValues>;
}

export const OptionGroupPricing = ({ formReturn }: IOptionGroupPricingProps) => {
  const {
    register,
    setValue,
    control,
    formState: { errors },
    trigger,
  } = formReturn;
  const { selectedPriceSchemeId } = useSelectedPriceScheme();
  const { data } = usePriceScheme(selectedPriceSchemeId);
  const priceSchemeName = data?.name;
  const optionGroupName = useWatch({ control, name: 'name' });
  const modifiers = useWatch({ control, name: 'modifiers' });

  return (
    <div className={cx('flex-column', 'container')}>
      <Typography size="xxlarge">
        Set prices for <span className={cx('bold-text')}>{optionGroupName}</span>
      </Typography>
      <Typography>Define the prices of products in your category for a specific Price Scheme</Typography>
      <Typography>
        Price Scheme - <span className={cx('bold-text')}>{priceSchemeName}</span>
      </Typography>
      <div className={cx('grid')}>
        <Typography weight="bold">Product Name</Typography>
        <Typography weight="bold">Inherit Product Price</Typography>
        <Typography weight="bold">Override Price*</Typography>
        {modifiers?.map((field, index) => (
          <Fragment key={field.optionItemId}>
            <Typography className={cx('truncate-text')}>{modifiers[index].name}</Typography>
            <div className={cx('checkbox')}>
              <Checkbox
                checked={modifiers[index].useDefaultPrice}
                onChange={() => {
                  setValue(`modifiers.${index}.useDefaultPrice`, !modifiers[index].useDefaultPrice);
                  setValue(`modifiers.${index}.valueWithTax`, null, { shouldValidate: true });
                }}
              />
            </div>
            <Input
              type="number"
              step={0.01}
              label="Price (£)"
              disabled={field.useDefaultPrice}
              register={register(`modifiers.${index}.valueWithTax`, {
                onChange: () => {
                  trigger('modifiers');
                },
                valueAsNumber: true,
                validate: (value, formValues) => {
                  if (!formValues.modifiers[index].useDefaultPrice && !value && value !== 0)
                    return 'Please enter a price';
                },
              })}
              error={errors?.modifiers?.[index]?.valueWithTax?.message}
            />
          </Fragment>
        ))}
      </div>
      <Typography size="small" weight="bold">
        *These prices will only be added to your {priceSchemeName} scheme, in order to use this category with
        alternative schemes, you will need to enter prices within those schemes
      </Typography>
    </div>
  );
};

export default OptionGroupPricing;
